// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';

// utilities
import cx from 'classnames';

// components
import Modal from '../../../../common/components/r_Modal';
import ModalX from '../../../../common/svgs/ModalX';

// material
import RaisedButton from '../../../../common/components/c_RaisedButton';

const flatButtonStyle = {
  width: '296px',
  height: '41px',
  marginRight: '25px'
};

const flatButtonLabelStyle = {
  fontSize: '12px',
  transform: 'translateY(-.5px)',
  top: 0
};


export default function NextStepBlocker(props) {
  const text = (props.transitionText)? props.transitionText : [`You have not completed the required fields needed to save. <br/>  If you exit the page now you will lose the information that hasn’t been saved.`]
  return (
    <Modal>
      <div className='next-step-blocker'>
        <div>
          <div className='prompt-text'
  dangerouslySetInnerHTML={{__html: text}}>
          </div>
          
          <RaisedButton
            label='Close'
            onClick={props.cancelFunc}
          />

        </div>
        <ModalX onClick={props.cancelFunc}/>
      </div>
      <div className='rectangle-behind-modal-form absolute-center'/>
    </Modal>
  );
}

NextStepBlocker.propTypes = {
  transitionFunc: PropTypes.func,
  cancelFunc: PropTypes.func,
  transitionText: PropTypes.text
};



// WEBPACK FOOTER //
// ./shared/react/client/JobRequest/NextStepBlocker/index.js